export function getQueryParam(name) {
    const escName = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + escName + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(window.location.href);
    if (results == null)
        return undefined;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
//# sourceMappingURL=getQueryParam.js.map